import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.date.to-string.js";
import { ElInput, ElButton, ElTabs, ElTabPane } from "element-plus";
import { getImgFromStr, getDateTimeStamp, getDateDiff, toDecimal, getPowerDownDateDiff, timestampToTime, formatDate, convertDateToTimestamp } from "../../unit/public";
import { ElMessage, ElLoading } from "element-plus";
import TradeWithAcitveKey from "../../components/TradeWithAcitveKey.vue";
export default {
  name: "TradePanel",
  components: {
    ElInput: ElInput,
    ElButton: ElButton,
    ElTabs: ElTabs,
    ElTabPane: ElTabPane,
    TradeWithAcitveKey: TradeWithAcitveKey
  },
  props: {
    account: {
      type: Object,
      required: true
    },
    loginData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      // Define any data properties needed for the trading panel
      steem: 0,
      sbd: 0,
      // Example balance
      activeTab: "buy",
      amount: 0,
      isShowModelTrade: false,
      price: 0,
      quantity: 0
    };
  },
  methods: {
    setPercentage: function setPercentage(percentage) {
      if (this.activeTab === "buy") {
        this.amount = toDecimal(this.account.sbd_balance * percentage / 100, 3);
        this.updateQuantity();
      } else {
        this.quantity = this.account.balance * percentage / 100;
        this.updateAmount();
      } //console.log(this.amount);

    },
    updateQuantity: function updateQuantity() {
      this.quantity = toDecimal(this.amount / this.price, 3);
    },
    updateAmount: function updateAmount() {
      this.amount = toDecimal(this.quantity * this.price, 3);
    },
    trade: function trade() {
      // Logic for buying
      if (this.loginData[4] == "true") {
        var that = this;
        var myAccount = this.loginData[0];
        var currentDate = new Date(); // Get the current date

        currentDate = new Date();
        var orderid = convertDateToTimestamp(formatDate(currentDate, "yyyy-MM-dd hh:mm:ss"));
        currentDate.setDate(currentDate.getDate() + 27);
        var expiration = formatDate(currentDate, "yyyy-MM-ddThh:mm:ss");
        var amount_to_sell = this.activeTab === "buy" ? toDecimal(this.amount, 3) + " SBD" : toDecimal(this.quantity, 3) + " STEEM";
        var min_to_receive = this.activeTab === "buy" ? toDecimal(this.quantity, 3) + " STEEM" : toDecimal(this.amount, 3) + " SBD";
        var op = [["limit_order_create", {
          owner: myAccount,
          orderid: orderid,
          amount_to_sell: amount_to_sell,
          min_to_receive: min_to_receive,
          fill_or_kill: false,
          expiration: expiration
        }]];
        window.steem_keychain.requestBroadcast(myAccount, op, "active", function (response) {
          if (response.success) {
            ElMessage({
              message: that.$t("success.tradeSuccess"),
              type: "success"
            });
          } else {
            ElMessage({
              message: that.$t("error.transError"),
              type: "error"
            });
          }
        });
      } else {
        this.isShowModelTrade = true;
      }
    },
    finishTrade: function finishTrade() {
      ElMessage({
        message: this.$t("success.tradeSuccess"),
        type: "success"
      });
      this.isShowModelTrade = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //console.log(this.account);
              _this.$bus.on("choosePrice", function (price) {
                _this.price = price;

                _this.updateQuantity();
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};